import { AxiosInstance } from '../../core/api/axiosinstance'
import { promiseToResult } from '../../core/api/promiseToResult'
import { objectToSnakeCase } from '../../utils/object.helper'
import { Field } from '../../state/types'

export enum SendCodeType {
  SMS = 'sms',
  CALL = 'call',
  FIREBASE = 'fb',
}

export interface AuthQuery {
  clickType?: string
  clickId?: string
  clickProductType?: string
  clickTerm?: string
  referer?: string
}

export interface ThirdPartyReq {
  accessToken: string
  username?: string
  birthday?: string
}
export interface ThirdPartyRes {
  form: {
    field: Record<string, Field>
    result: string
  }
}
const thirdParty = (data: ThirdPartyReq) => {
  return promiseToResult(AxiosInstance().post<ThirdPartyRes>(
    '/auth/third-party',
    objectToSnakeCase(data),
  ))
}

export interface ThirdPartyLoginReq {
  accessToken: string
}
export interface ThirdPartyLoginRes {
  form: {
    field: Record<string, Field>
    result: { token: string }
  }
}
const thirdPartyLogin = (data: ThirdPartyLoginReq) => {
  return promiseToResult(AxiosInstance().post<ThirdPartyLoginRes>(
    '/auth/third-party-v2/login',
    objectToSnakeCase(data),
  ))
}

export interface LoginTokenReq {
  login: string
  password: string
}
export interface LoginTokenRes {
  result: string
  token: string
}
const loginToken = (data: LoginTokenReq) => {
  return promiseToResult(AxiosInstance().post<LoginTokenRes>(
    '/login/token',
    objectToSnakeCase(data),
  ))
}

export interface PostValidateReq {
  firstname?: string
  midlename?: string
  lastname?: string
  gender?: string
  birthday?: string
  passport?: string
  passportDate?: string
  email?: string
  phone?: string
  countryId?: number
}
export interface PostValidateRes {
  message?: Record<keyof PostValidateReq, string[]>
}
const postValidate = (data: PostValidateReq) => {
  return promiseToResult(AxiosInstance().post<PostValidateRes>(
    '/registration/validate',
    objectToSnakeCase(data),
  ))
}

export interface GetValidatePhoneReq {
  phone: string
}
export interface GetValidatePhoneRes {
  phone: string
  country: string
  type: SendCodeType
}
const getValidatePhone = (data: GetValidatePhoneReq) => {
  const { phone } = data
  return promiseToResult(AxiosInstance().get<GetValidatePhoneRes>(
    `/validate-phone?phone=${phone.replace(/[+\-() ]/g, '')}`,
  ))
}

export interface PostRegSendCallReq {
  phone: string
}
export interface PostRegSendCallRes {
  result: 'success'
}
const postRegSendCall = (data: PostRegSendCallReq) => {
  return promiseToResult(AxiosInstance().post<PostRegSendCallRes>(
    '/registration/send-call-code',
    objectToSnakeCase(data),
  ))
}

export interface PostRegValidateCallReq {
  phone?: string
  callCode?: string
}
export interface PostRegValidateCallRes {
  status: boolean
  message: Record<keyof PostRegValidateCallReq, string[]>
}
const postRegValidateCall = (data: PostRegValidateCallReq) => {
  return promiseToResult(AxiosInstance().post<PostRegValidateCallRes>(
    '/registration/call-code',
    objectToSnakeCase(data),
  ))
}

export interface PostRegSendSmsReq {
  phone: string
}
export interface PostRegSendSmsRes {
  status: boolean
}
const postRegSendSms = (data: PostRegSendSmsReq) => {
  return promiseToResult(AxiosInstance().post<PostRegSendSmsRes>(
    '/registration/send-sms-code',
    objectToSnakeCase(data),
  ))
}

export interface PostRegValidateReq {
  phone?: string
  smsCode?: string
  firstname?: string
}
export interface PostRegValidateRes {
  status: boolean
  message?: Record<keyof PostRegValidateReq, string[]>
}
const postRegValidate = (data: PostRegValidateReq) => {
  return promiseToResult(AxiosInstance().post<PostRegValidateRes>(
    '/registration/validate',
    objectToSnakeCase(data),
  ))
}

export interface PostRegReq {
  phone: string
  firstname: string
  userLanguageId: number
  scenario: 3
}
export interface PostRegRes {
  result: 'success'
  token: string
}
const postReg = (data: PostRegReq) => {
  return promiseToResult(AxiosInstance().post<PostRegRes>(
    '/reg/register',
    objectToSnakeCase(data),
  ))
}

export const AuthAPI = {
  thirdParty,
  thirdPartyLogin,
  loginToken,
  postValidate,
  getValidatePhone,
  postRegSendCall,
  postRegValidateCall,
  postRegSendSms,
  postRegValidate,
  postReg,
}
